import React from 'react';
import { useAtomValue } from 'jotai';
import { panelsAtom } from '../atoms';
import { EventsDashboardWrapper, EventsWrapper } from './styled';
import Header from './Header';
import EventsTable from './table';
import ErrorBoundary from '../../common/Retry/ErrorBoundary';

const EventsPanel = () => {
  const panels = useAtomValue(panelsAtom);

  return (
    <ErrorBoundary>
      <EventsDashboardWrapper style={{ display: panels.events ? 'block' : 'none' }}>
        <EventsWrapper>
          <Header />
          <EventsTable />
        </EventsWrapper>
      </EventsDashboardWrapper>
    </ErrorBoundary>
  );
};

export default EventsPanel;
